export default {
  US: 'U.S.',
  CA: 'Canada',
  PL: 'Poland',
  IE: 'Ireland',
  UK: 'United Kingdom',
  GB: 'United Kingdom',
  AU: 'Australia'
}
